/** @jsxImportSource @emotion/react */
import isString from 'lodash/isString';
import React from 'react';

import useTranslate from '@common/hooks/useTranslate';
import ArrowRight from '@stories/atoms/Icons/arrow_right.svg';
import { SectionShort } from '@stories/atoms/Section/Section';
import { media } from '@stories/theming/settings';
import { translations } from '@utils/translations';

import type { GetHygraphIcpDataQuery } from '@gql/hygraph/graphql';

interface ICrossLinksProps {
  crossLinks?: NonNullable<GetHygraphIcpDataQuery['category']>['icpCrossLinks'];
  headline?: string | null;
}
interface ICrossLinkProps {
  to: string;
  name: string;
}
const CrossLink: React.FC<ICrossLinkProps> = ({ to, name }) => {
  return (
    <a href={to} css={{ width: '100%', [media('desktop')]: { width: '30rem' } }}>
      <div
        css={(t) => ({
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          borderBottom: `1px solid ${t.color.grey.g92}`,
          padding: '0.5rem',
          '&:hover': {
            color: t.color.hover.copy,
            textDecoration: 'underline',
            svg: { fill: t.color.primary }
          },
          [media('desktop')]: {
            padding: '1rem 0.5rem'
          }
        })}
      >
        <ArrowRight css={{ height: '1rem', width: '1rem', marginRight: '0.5rem' }} />
        <div>{name}</div>
      </div>
    </a>
  );
};
const CrossLinks: React.FC<ICrossLinksProps> = ({ crossLinks, headline }) => {
  const t = useTranslate(translations);
  return (
    <SectionShort headline={t(headline)}>
      <div
        css={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'column',
          flexWrap: 'nowrap',
          margin: '2rem 0 2rem 0',
          [media('desktop')]: {
            padding: '0 4rem 0 4rem',
            width: '100%',
            flexWrap: 'wrap',
            flexDirection: 'row'
          }
        }}
      >
        {crossLinks?.map((link) => {
          if (!isString(link.label)) return null;
          return <CrossLink name={link.label} to={link.url} key={link.id}></CrossLink>;
        })}
      </div>
    </SectionShort>
  );
};

export default CrossLinks;
